import { c as _c } from "react/compiler-runtime";
import { SquareSlashIcon } from "lucide-react";
import { useState } from "react";
import { HexAlphaColorPicker, HexColorInput } from "react-colorful";
import { cn } from "@/lib/utils";
import { useDidUpdate } from "@/ui/hooks/lifecycle";
import { useDebounce } from "@/ui/hooks/use-debounced-value";
import { Popover, PopoverContent, PopoverTrigger } from "./shadcn/popover";
export const StatefulColorPicker = t0 => {
  const $ = _c(30);
  const {
    value,
    defaultValue,
    onValueChange
  } = t0;
  const [color, setColor] = useState(value ?? defaultValue);
  let t1;
  let t2;
  if ($[0] !== value) {
    t1 = () => {
      value && setColor(value);
    };
    t2 = [value];
    $[0] = value;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useDidUpdate(t1, t2);
  const onColorChange = useDebounce(onValueChange ?? _temp, 200);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = cn("w-6 h-6 aspect-square rounded ring-1 ring-offset-1 ring-neutral-500/25 transition-shadow", "focus:outline-hidden focus:ring-blue-500", "hover:ring-blue-500");
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = color ?? undefined;
  let t5;
  if ($[4] !== t4) {
    t5 = {
      backgroundColor: t4
    };
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = `Select color ${color}`;
  let t7;
  if ($[6] !== color) {
    t7 = color ? "" : <SquareSlashIcon className="size-4 mx-auto text-muted-foreground/30" />;
    $[6] = color;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t6 || $[10] !== t7) {
    t8 = <PopoverTrigger asChild={true}><button type="button" className={t3} style={t5} aria-label={t6}>{t7}</button></PopoverTrigger>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = color ?? "#23d2f1ff";
  let t10;
  if ($[12] !== onColorChange) {
    t10 = color_0 => {
      setColor(color_0);
      onColorChange?.(color_0);
    };
    $[12] = onColorChange;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t9) {
    t11 = <PopoverContent className="w-auto p-0" align="start"><HexAlphaColorPicker color={t9} onChange={t10} /></PopoverContent>;
    $[14] = t10;
    $[15] = t9;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t8) {
    t12 = <Popover>{t8}{t11}</Popover>;
    $[17] = t11;
    $[18] = t8;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  const t13 = color ?? undefined;
  let t14;
  let t15;
  if ($[20] !== onColorChange) {
    t14 = e => {
      if (!e.currentTarget.value || e.currentTarget.value === "#") {
        setColor(null);
        onColorChange?.(null);
      }
    };
    t15 = color_1 => {
      setColor(color_1);
      onColorChange?.(color_1);
    };
    $[20] = onColorChange;
    $[21] = t14;
    $[22] = t15;
  } else {
    t14 = $[21];
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t14 || $[25] !== t15) {
    t16 = <HexColorInput color={t13} onBlur={t14} onChange={t15} alpha={true} prefixed={true} className="bg-white border rounded px-2 h-6 w-[9ch] box-content font-mono" />;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== t12 || $[28] !== t16) {
    t17 = <div className="flex gap-2 items-center">{t12}{t16}</div>;
    $[27] = t12;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  return t17;
};
function _temp() {}